export enum ParametrosMaestro {
  EstadosSolicitudes = 1,
  EstadosUsuarios = 2,
  TiposUsuario = 3,
  EstadosInducciones = 5,
  TIPO_REQUISITO = 7,
  TiposDocumentosIdentidad = 8,
  ESTADO_ACCESO_PERSONA = 10,
  ESTADO_CONFIG_CONTRATISTA = 13,
  ESTADO_CONFIG_SEDE = 14,
  ESTADO_CONFIG_TIPO_VISITA = 15,
  ESTADO_CONFIG_DOCUMENTO = 16,
  VigenciaInduccion = 17,
  TIPO_CREACION_SOL = 18,
  ESTADO_CONFIG_MAESTRO = 19,
  ESTADOS_ACCION_HIPO = 20,
  ESTADOS_FICHA_SSO = 21,
  TIPO_SOLICITUD_AMPLIACION = 22,
  ESTADOS_SOLICITUD_AMPLIACION = 23,
  CALENDARIO_SSO_FECHA_DEFAULT = 24,
  ESTADOS_CARGA_PROGRAMACION_PASST = 25,
  ESTADOS_PASST_ACTIVIDAD_PROGRAMADA = 26,
  ESTADOS_PASST_ACTIVIDAD_EJECUCION = 27,
  ESTADOS_EDICION_PASST_ACTIVIDAD = 28,
  ESTADOS_EDICION_PASST_PROGRAMACION = 29,
  TIPO_CARGA_PASST = 30,
  VARIABLES_SISTCONTROL = 31,
  PARAMETROS_CONFIGURACION = 32
}

export enum SolicitudSeccion {
  Personal = 1,
  Equipos = 2,
  Vehiculos = 3,
  DocumentacionTecnica = 4,
}

export enum EstadoSolicitudItem {
  PENDIENTE = 0,
  APROBADO = 1,
  OBSERVADO = 2,
}

export enum EstadoSolicitudPersonaItem {
  PENDIENTE = 0,
  APROBADO = 1,
  OBSERVADO = 2,
}

export enum EstadoSolicitudEquipoItem {
  PENDIENTE = 0,
  APROBADO = 1,
  OBSERVADO = 2,
}

export enum EstadoSolicitudVehiculoItem {
  PENDIENTE = 0,
  APROBADO = 1,
  OBSERVADO = 2,
}

export enum EstadoDocumentoItem {
  PENDIENTE = 0,
  APROBADO = 1,
  OBSERVADO = 2,
  POR_REEMPLAZAR = 3,
  VENCIDO = 4,
  POR_VALIDAR_RENOVACION = 5,
}

export enum EstadoSolicitud {
  EN_ELABORACION = 1,
  SOLICITADO = 2,
  EN_REVISION = 3,
  REVISADO = 4,
  OBSERVADO = 5,
  FINALIZADO = 6,
  RECHAZADO = 7,
  PROGRAMACION_INDUCCION = 8,
  RESULTADOS_INDUCCION = 9,
  AUTORIZACION_ACCESOS = 10,
  STAND_BY = 11,
}

export enum TipoUsuario {
  Empleado = 1,
  Contratista = 2,
}

export enum DocumentoTipoRequisito {
  TODOS = 1,
  ALGUNOS = 2,
}

export enum InduccionEstado {
  EMPTY = 0,
  PENDIENTE = 1,
  PROGRAMADO = 2,
  APROBADO = 3,
  RECHAZADO = 4,
  VENCIDO = 5,
  SUSPENDIDO = 6,
}

export enum AccesoEstado {
  // VALIDO = 1,
  // VENCIDO = 2,
  AUTORIZADO = 1,
  NO_AUTORIZADO = 2,
  BLOQUEADO = 3,
  VENCIDO = 4,
  PENDIENTE = 5
}

export enum OtroDocumentoSecciones {
  OTRO_DOCUMENTO_PERSONAL = 1,
  OTRO_DOCUMENTO_EQUIPO = 2,
  OTRO_DOCUMENTO_VEHICULO = 3,
  OTRO_DOCUMENTO_TECNICO = 4,
}

export enum Roles {
  SOLICITANTE = 1,
  COORDINADOR_SSO = 2,
  REVISOR = 3,
  CONTRATISTA = 4,
  SUPERVISOR = 5,
  ADMINISTRADOR = 6,
  VIGILANTE = 7,
  ADMINISTRADORSSO = 8,
  RESPONSABLEHIPO = 9
}

export enum TipoFiltro {
  MIS_SOLICITUDES = 1,
  TODAS = 2,
}

export enum eTipoOrigenInduccion {
  SOLICITUD = 1,
  RENOVACION_INDUCCION = 2,
}

export enum eEstadoContratista {
  ACTIVO = 1,
  INACTIVO,
}

export enum eEstadoSede {
  ACTIVO = 1,
  INACTIVO,
}

export enum eEstadoTipoVisita {
  ACTIVO = 1,
  INACTIVO,
}

export enum eEstadoDocumento {
  ACTIVO = 1,
  INACTIVO,
}

export enum eEstadoUsuario {
  TODOS = 0,
  HABILITADO = 1,
  DESHABILITADO,
}
export enum eTypeResult {
  SUCCESS = 1,
  WARNING = 2,
  ERROR = 3,
}

export enum eTipoCreacion {
  ENGIE = 1,
  CONTRATISTA,
}

export enum eEstadoMaestro {
  ACTIVO = 1,
  INACTIVO,
}

export enum eEstadoAccionHipo {
  Pendiente = 1,
  Cerrado = 2,
}

export enum eEstadoFichaSso {
  Pendiente = 1,
  Completado = 2,
  CompletadoFueraPlazo = 3,
  NoReportado = 4,
  AmpliacionSolicitada = 5,
  CompletadoAdministrador = 6,
}

export enum TipoSolicitudAmpliacion {
  AmpliacionSSO = 1,
  NuevaEmpresa = 2,
  ModificacionActividadPASST = 3,
  ModificacionProgramacionPASST = 4,
}

export enum eEstadoSolicitudAmpliacion {
  Pendiente = 1,
  Aprobado = 2,
  Rechazado = 3,
  CerradoIncompleto= 4,
}

export enum TipoCargaPASST {
  Programacion = 1,
  Ejecucion = 2,
}

export enum eEstadoPasstAcitividadProgramada {
  Programado = 1,
  Reprogramado = 2,
}

export enum eEstadoPasstAcitividadEjecucion {
  Ejecutado = 1,
  Reprogramado = 2,
  Cancelado = 3,
}

export enum eEstadosEdicionPasstAcitividad {
  EdicionDeshabilitada = 1,
  EdicionSolicitada = 2,
  EdicionAprobada = 3,
}